import { ReactNode } from 'react'
import Image from 'next/image'

import FormattedText from 'shared/ui/FormattedText'
import InfoTile from 'shared/ui/Tiles/InfoTile'

import styles from './WhyUs.module.scss'

interface WhyUsTile {
  icon: ReactNode
  title: string
  text: ReactNode | string
  backgroundColor?: string
  color?: string
}
interface WhyUsProps {
  header?: string
  tiles?: WhyUsTile[]
}

const defaultProps: WhyUsProps = {
  header: 'Dlaczego warto u nas kupować?',
  tiles: [
    {
      icon: (
        <Image
          width={0}
          height={0}
          fill
          src='/static/about-us/delivery.svg'
          alt='Wygoda'
          quality={100}
          sizes='105px'
        />
      ),
      title: 'Wygoda',
      text: 'Dostarczamy bezpośrednio do domu, prosto do Twoich drzwi, z zachowaniem ciągu chłodniczego.'
    },
    {
      icon: (
        <Image
          width={0}
          height={0}
          fill
          src='/static/about-us/authenticity.svg'
          alt='Autentyczność'
          quality={100}
          sizes='105px'
        />
      ),
      title: 'Autentyczność',
      text: 'Za każdym produktem stoją ludzie pełni pasji, których historie chcemy Ci pokazywać.'
    },
    {
      icon: (
        <Image
          width={0}
          height={0}
          fill
          src='/static/about-us/responsibility.svg'
          alt='Odpowiedzialność'
          quality={100}
          sizes='105px'
        />
      ),
      title: 'Odpowiedzialność',
      text: 'Wspieramy małych producentów, dbamy o środowisko i naszą planetę.'
    },
    {
      icon: (
        <Image
          width={0}
          height={0}
          fill
          src='/static/about-us/honest.svg'
          alt='Uczciwość'
          quality={100}
          sizes='105px'
        />
      ),
      title: 'Uczciwość',
      text: 'Jesteśmy transparentni wobec klientów i dostawców, bo uczciwość to fundament, na którym zbudowaliśmy nasz sklep.'
    }
  ]
}

const WhyUs = ({
  header = defaultProps.header,
  tiles = defaultProps.tiles
}: WhyUsProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.infoboxHeadline}>
        <FormattedText text={header} />
      </div>
      <div className={styles.infoTileWrapper}>
        {tiles?.map(({ icon, title, text, backgroundColor, color }) => (
          <InfoTile
            key={title}
            icon={
              typeof icon === 'string' ? (
                <Image
                  width={0}
                  height={0}
                  fill
                  src={icon}
                  alt={title || ''}
                  quality={100}
                  sizes='48px'
                />
              ) : (
                icon
              )
            }
            title={title}
            text={text}
            backgroundColor={backgroundColor}
            color={color}
          />
        ))}
      </div>
    </div>
  )
}

export default WhyUs
